(function () {
  'use strict';

  var mapsPromises = {};
  var authFailureNotified = false;

  function notifyMapsAuthFailure() {
    window.__storeLocatorGmAuthFailed = true;
    if (authFailureNotified) return;
    authFailureNotified = true;
    document.querySelectorAll('[data-store-locator-root]').forEach(function (root) {
      root.dispatchEvent(new CustomEvent('store-locator:gm-auth-failure', { bubbles: false }));
    });
  }

  if (typeof window.gm_authFailure !== 'function') {
    window.gm_authFailure = notifyMapsAuthFailure;
  }

  function loadGoogleMapsApi(apiKey) {
    var key = (apiKey || '').trim();
    if (!key) return Promise.reject(new Error('no key'));
    if (window.google && window.google.maps && window.google.maps.Map) {
      return Promise.resolve();
    }
    if (mapsPromises[key]) return mapsPromises[key];
    mapsPromises[key] = new Promise(function (resolve, reject) {
      var cbId =
        '__storeLocatorMapsInit_' +
        key.slice(0, 6).replace(/\W/g, '') +
        '_' +
        String(Date.now()) +
        '_' +
        Math.random().toString(36).slice(2, 8);

      var done = false;
      function finish(ok) {
        if (done) return;
        done = true;
        try {
          delete window[cbId];
        } catch (e) {
          window[cbId] = undefined;
        }
        if (ok) resolve();
        else reject(new Error('no google maps'));
      }

      window[cbId] = function () {
        if (window.google && window.google.maps && window.google.maps.Map) {
          finish(true);
        } else {
          finish(false);
        }
      };

      var s = document.createElement('script');
      s.async = true;
      s.defer = true;
      s.onerror = function () {
        delete mapsPromises[key];
        try {
          delete window[cbId];
        } catch (e2) {
          window[cbId] = undefined;
        }
        reject(new Error('script error'));
      };
      s.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(key) +
        '&v=weekly&callback=' +
        encodeURIComponent(cbId);
      document.head.appendChild(s);
    });
    return mapsPromises[key];
  }

  function parseStores(root) {
    var el = root.querySelector('[data-store-locator-json]');
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function storeMatches(store, country, city) {
    if (country && store.country !== country) return false;
    if (city && store.city !== city) return false;
    return true;
  }

  function escapeHtml(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function escapeAttr(s) {
    if (!s) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function popupHtml(store, directionsLabel) {
    var parts = [
      '<div class="store-locator__gmap-info">',
      '<p class="store-locator__popup-title">' + escapeHtml(store.title) + '</p>',
      '<p class="store-locator__popup-meta">' + escapeHtml(store.city) + (store.country ? ', ' + escapeHtml(store.country) : '') + '</p>',
    ];
    if (store.address) {
      parts.push(
        '<p>' +
          escapeHtml(store.address).replace(/\r\n|\r|\n/g, '<br>') +
          '</p>'
      );
    }
    if (store.directions_url) {
      parts.push(
        '<p><a href="' +
          escapeAttr(store.directions_url) +
          '" target="_blank" rel="noopener noreferrer">' +
          escapeHtml(directionsLabel || 'Directions') +
          '</a></p>'
      );
    }
    parts.push('</div>');
    return parts.join('');
  }

  function initRoot(root) {
    var stores = parseStores(root);
    var countrySel = root.querySelector('[data-store-locator-country]');
    var citySel = root.querySelector('[data-store-locator-city]');
    var mapEl = root.querySelector('[data-store-locator-map]');
    var countEl = root.querySelector('[data-store-locator-count]');
    var cards = root.querySelectorAll('[data-store-locator-card]');
    var apiKey = (root.dataset.googleMapsApiKey || '').trim();
    var directionsLabel = root.dataset.directionsLabel || 'Directions';
    var markerIconUrl = root.dataset.markerIconUrl || '';
    var markerW = parseInt(root.dataset.markerWidth, 10);
    var markerH = parseInt(root.dataset.markerHeight, 10);
    var hasCustomMarker =
      Boolean(markerIconUrl) && !isNaN(markerW) && markerW > 0 && !isNaN(markerH) && markerH > 0;

    if (!countrySel || !citySel || !mapEl) return;

    var countries = uniqueSorted(stores.map(function (s) { return s.country; }));
    var mapInstance = null;
    var gMarkers = [];
    var infoWindow = null;

    function fillCountries() {
      countrySel.innerHTML = '';
      var all = document.createElement('option');
      all.value = '';
      all.textContent = root.dataset.allCountriesLabel || 'All countries';
      countrySel.appendChild(all);
      countries.forEach(function (c) {
        var o = document.createElement('option');
        o.value = c;
        o.textContent = c;
        countrySel.appendChild(o);
      });
    }

    function citiesForCountry(selectedCountry) {
      var list = stores
        .filter(function (s) { return !selectedCountry || s.country === selectedCountry; })
        .map(function (s) { return s.city; });
      return uniqueSorted(list);
    }

    function fillCities(country) {
      var current = citySel.value;
      citySel.innerHTML = '';
      var all = document.createElement('option');
      all.value = '';
      all.textContent = root.dataset.allCitiesLabel || 'All cities';
      citySel.appendChild(all);
      citiesForCountry(country).forEach(function (c) {
        var o = document.createElement('option');
        o.value = c;
        o.textContent = c;
        citySel.appendChild(o);
      });
      if (current && Array.prototype.some.call(citySel.options, function (opt) { return opt.value === current; })) {
        citySel.value = current;
      } else {
        citySel.value = '';
      }
    }

    function visibleStores() {
      var c = countrySel.value;
      var t = citySel.value;
      return stores.filter(function (s) { return storeMatches(s, c, t); });
    }

    function updateCards(list) {
      var ids = new Set(list.map(function (s) { return s.id; }));
      cards.forEach(function (card) {
        var id = card.getAttribute('data-store-id');
        card.hidden = !ids.has(id);
      });
      if (countEl) {
        var n = list.length;
        var tmpl = root.dataset.resultsLabel || '';
        countEl.textContent = tmpl.replace(/\{count\}/g, String(n));
      }
    }

    function clearGMarkers() {
      gMarkers.forEach(function (m) {
        m.setMap(null);
      });
      gMarkers = [];
    }

    function destroyMapUi() {
      clearGMarkers();
      if (infoWindow) {
        infoWindow.close();
        infoWindow = null;
      }
      mapInstance = null;
      mapEl.innerHTML = '';
    }

    function showMapMessage(text) {
      destroyMapUi();
      mapEl.classList.add('store-locator__map--empty');
      var p = document.createElement('p');
      p.setAttribute('aria-live', 'polite');
      p.textContent = text;
      mapEl.appendChild(p);
    }

    root.addEventListener('store-locator:gm-auth-failure', function () {
      showMapMessage(
        root.dataset.mapAuthErrorLabel ||
          root.dataset.mapErrorLabel ||
          'Google Maps could not load. Check your API key, billing, and referrer restrictions in Google Cloud Console.'
      );
    });

    function updateMap(list) {
      var withCoords = list.filter(function (s) {
        var lat = parseFloat(s.latitude);
        var lng = parseFloat(s.longitude);
        return !isNaN(lat) && !isNaN(lng);
      });

      if (withCoords.length === 0) {
        showMapMessage(root.dataset.noCoordsLabel || 'No map preview for this selection.');
        return;
      }

      if (!apiKey.trim()) {
        showMapMessage(
          root.dataset.missingKeyLabel || 'Add a Google Maps API key in the theme editor to show the map.'
        );
        return;
      }

      if (window.__storeLocatorGmAuthFailed) {
        showMapMessage(
          root.dataset.mapAuthErrorLabel ||
            root.dataset.mapErrorLabel ||
            'Google Maps could not load. Check your API key, billing, and referrer restrictions in Google Cloud Console.'
        );
        return;
      }

      loadGoogleMapsApi(apiKey)
        .then(function () {
          var iconOpt = null;
          if (hasCustomMarker) {
            iconOpt = {
              url: markerIconUrl,
              scaledSize: new google.maps.Size(markerW, markerH),
              anchor: new google.maps.Point(Math.round(markerW / 2), markerH),
            };
          }

          mapEl.classList.remove('store-locator__map--empty');
          if (!mapInstance) {
            mapEl.innerHTML = '';
            mapInstance = new google.maps.Map(mapEl, {
              zoom: 12,
              center: {
                lat: parseFloat(withCoords[0].latitude),
                lng: parseFloat(withCoords[0].longitude),
              },
              mapTypeControl: true,
              streetViewControl: false,
              fullscreenControl: true,
              gestureHandling: 'cooperative',
            });
            infoWindow = new google.maps.InfoWindow();
          }

          clearGMarkers();

          withCoords.forEach(function (s) {
            var lat = parseFloat(s.latitude);
            var lng = parseFloat(s.longitude);
            var markerOptions = {
              position: { lat: lat, lng: lng },
              map: mapInstance,
              title: s.title || '',
            };
            if (iconOpt) markerOptions.icon = iconOpt;
            var marker = new google.maps.Marker(markerOptions);
            marker.addListener('click', function () {
              infoWindow.setContent(popupHtml(s, directionsLabel));
              infoWindow.open(mapInstance, marker);
            });
            gMarkers.push(marker);
          });

          if (withCoords.length === 1) {
            mapInstance.setCenter({
              lat: parseFloat(withCoords[0].latitude),
              lng: parseFloat(withCoords[0].longitude),
            });
            mapInstance.setZoom(14);
          } else {
            var bounds = new google.maps.LatLngBounds();
            withCoords.forEach(function (s) {
              bounds.extend({
                lat: parseFloat(s.latitude),
                lng: parseFloat(s.longitude),
              });
            });
            mapInstance.fitBounds(bounds, { top: 40, right: 40, bottom: 40, left: 40 });
            google.maps.event.addListenerOnce(mapInstance, 'idle', function () {
              if (mapInstance.getZoom() > 15) mapInstance.setZoom(15);
            });
          }

          setTimeout(function () {
            if (mapInstance) google.maps.event.trigger(mapInstance, 'resize');
          }, 100);
        })
        .catch(function () {
          showMapMessage(
            root.dataset.mapErrorLabel || 'The map could not be loaded. Please try again later.'
          );
        });
    }

    function applyFilters() {
      var list = visibleStores();
      updateCards(list);
      updateMap(list);
    }

    fillCountries();
    fillCities('');

    countrySel.addEventListener('change', function () {
      fillCities(countrySel.value);
      applyFilters();
    });
    citySel.addEventListener('change', applyFilters);

    applyFilters();

    window.addEventListener(
      'resize',
      function () {
        if (mapInstance && window.google && window.google.maps) {
          google.maps.event.trigger(mapInstance, 'resize');
        }
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-store-locator-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
